import { html } from '@design.estate/dees-element';

// A loopback demo: keystrokes echo straight back into the terminal so the
// component is explorable without a live PTY behind it.
export const demoFunc = () => html`
  <style>
    .terminalDemo {
      height: 380px;
      border: 1px solid var(--dees-color-border-default);
      border-radius: 8px;
      overflow: hidden;
    }
  </style>
  <div class="terminalDemo">
    <dees-terminal-view
      @terminal-input=${(event: CustomEvent<{ data: string }>) => {
        const view = event.currentTarget as HTMLElementTagNameMap['dees-terminal-view'];
        const data = event.detail.data;
        view.write(data === '\r' ? '\r\n' : data);
      }}
      @terminal-resize=${(event: CustomEvent<{ rows: number; cols: number }>) => {
        console.log('terminal size', event.detail);
      }}
    ></dees-terminal-view>
  </div>
`;
